import { advancementTypes } from '@shared/constants';
import { esbApiService } from '@utils';

const getUnapproveAdvancementType = type => {
  switch (type) {
    case advancementTypes.AWARDS: {
      return 'Award';
    }
    case advancementTypes.ADVENTURES: {
      return 'Adventure';
    }
    case advancementTypes.RANKS: {
      return 'Rank';
    }
    case advancementTypes.MERIT_BADGES: {
      return 'Merit Badge';
    }
    default: {
      throw new Error(`Advancement Type ${type} not valid`);
    }
  }
};

const unapproveAdvancement$ = ({
  userId,
  organizationGuid,
  advancementType,
  advancementId,
  userAwardId,
  newStatus,
}) =>
  esbApiService.post$(
    '/advancements/unapprove',
    [
      {
        userId: Number(userId),
        organizationGuid,
        advancementId: Number(advancementId),
        userAwardId: userAwardId ? userAwardId : null,
        advancementType: getUnapproveAdvancementType(advancementType),
        newStatus: newStatus ? newStatus : 'Not Complete',
      },
    ],
    {
      gtm: {
        label: '/advancements/unapprove',
      },
    },
  );

const unapproveMultipleAdvancement$ = payload =>
  esbApiService.post$('/advancements/unapprove', payload, {
    gtm: {
      label: '/advancements/unapprove',
    },
  });

const uncompleteMultipleRequirements$ = args =>
  esbApiService.post$(
    `/advancements/v2/youth/${args.advancementType}/${args.advancementId}/requirements`,
    args.payload,
    {
      gtm: {
        label:
          '/advancements/v2/youth/:advancementType/:advancementId/requirements',
      },
    },
  );

export default {
  unapproveAdvancement$,
  unapproveMultipleAdvancement$,
  uncompleteMultipleRequirements$,
};
